/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [
  {
    name: '视频',
    type: 'module-name',
  },
  {
    key: 'property_data',
    name: '属性',
    type: 'custom',
    content: [
      {
        key: 'video_url',
        name: '视频',
        type: 'video',
      },
      {
        key: 'image_url',
        name: '封面',
        type: 'choose-photo',
        memo: '建议宽度：710px*356px',
      },
      {
        key: 'ratio',
        name: '宽高比',
        type: 'text',
        memo: '建议计算原视频尺寸宽高比',
      },
      {
        key: 'margin_num',
        name: '左右外间距',
        type: 'slider',
      },
      {
        key: 'padding_num',
        name: '左右内间距',
        type: 'slider',
      },
      {
        key: 'radius',
        name: '视频圆角',
        type: 'slider',
      },
      {
        key: 'video_radius',
        name: '组件圆角',
        type: 'slider',
      },
      {
        key: 'bg_color',
        name: '背景色',
        type: 'color',
      },
    ],
  },
];

export default config;